import React, { useEffect } from "react";
import Title from "./Components/Title";
import DefaultLayout from "../Containers/Layout/DefaultLayout";

const AlbumListeningEvent = () => {
  var album = "https://streams.radiomast.io/station/458cb1fa-5d67-4e84-9272-5fae8812546b/player/widget?t=dark&s=8ebd33a7-592c-4eba-8049-25b0a10038cc";
  useEffect(() => {
    var addScript = document.createElement("script");
    addScript.setAttribute(
      "src",
      "//rumbletalk.com/client/?B_aLnmdZ"
    );
    document.body.appendChild(addScript);
  }, []);
  return (
    <div className="page sonos">
      <Title value="Album Listening Event" />
      <DefaultLayout
        disablePlayer
        disableBanner
        disableNavItems
      >
      <main className="sonos-lander">
        <section className="hero">
          <iframe title="radiomast-player" style={{ height: "500px", flex:1 }} src={album} width="360" scrolling="no" frameBorder="0" allow="autoplay" ></iframe>
          <div style={{ height: "500px", flex:1 }} id="rumble-container"><div id="rt-2ce7eea6437e4f137a65ba95f2b41672"></div></div>
        </section>
      </main>
      </DefaultLayout>
    </div>
  );
};

export default AlbumListeningEvent;
